import Enum from './enum'

class AdditionalSpecItemState extends Enum
{
  constructor(value) {
    super(value);
  }
}

AdditionalSpecItemState.init({
  NONE: 'None',
  APPROVED: 'Approved',
  DECLINED: 'Declined'
}, {
  NONE: 'additional-spec-item-state.none',
  APPROVED: 'additional-spec-item-state.approved',
  DECLINED: 'additional-spec-item-state.declined',
});

export default AdditionalSpecItemState;
